<template>
  <div id="Contract" class="fit q-px-md">
    <crud-layout-search
      ref="crudLayoutSearch"
      :interface="nmInterface"
      :name="name"
      :pageDetail="pageDetail"
      :page-table="pageTable"
      class="contract"
      maximized
    />
    <modal
      v-if="modalData.show"
      ref="modal"
      :show="modalData.show"
      v-bind="modalData"
      :maximized="false"
      @input="(show) => (modalData.show = show)"
      @action-button="downloadReport"
      :label="this.$gettext('GENERATE_REPORT')"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import ContractPage from './ContractPage'
import PageDetail from './ContractDetail'
import ContractUpdate from './ContractUpdate'
import ContractPageTable from './ContractPageTable'
import { repository } from 'src/jtech/jtech-repository'

const { modal } = JtCrud
const CrudLayoutSearch = JtCrud.CrudLayoutSearch

@Component({
  name: 'Contract',
  components: {
    CrudLayoutSearch,
    ContractPage,
    ContractUpdate,
    ContractPageTable,
    modal
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Contract extends Vue {
  flModal = false;
  formsModal = null;
  modalData = { show: false }
  fileSrc = null
  reportTitle = null

  reportFormat = {
    pdf: false,
    xls: true
  }

  mounted () {
    try {
      this.$refs.crudLayoutSearch.onButton('btPesquisarRel', this.openModal)
    } catch (error) {
      console.error(error)
    }
  }

  async openModal (button, params) {
    const forms = await repository.resolve('contractReport.contractReport', {})
    this.modalData = {
      show: true,
      forms: forms,
      label: button.label,
      params: params
    }
  }

  async downloadReport (button, params) {
    const reportTitle = params.reportStatus ? this.$gettext('CONTRACT_REPORT') : this.$gettext('CONTRACT_REPORT_RESIDUE')
    const reportOptions = {
      cdRelatorio: reportTitle,
      relFormaGeracao: 1,
      relFormatoRelatorio: 3,
      available: params.available
    }

    const { nmArquivo } = await this.$jt.repository.resolveLogic(
      params.reportStatus ? 'contractReport.contractReport' : 'contractReportResidue.contractReportResidue',
      reportOptions
    )

    const format = 'xls'
    const result = await repository.downloadFile(
      nmArquivo,
      format,
      '',
      'application/' + format
    )

    this.fileSrc = URL.createObjectURL(result)

    this.$nextTick(() => {
      if (this.reportFormat.xls) {
        this.__downloadFile(this.fileSrc, reportTitle, '.xls')
      } else {
        this.$refs.reportModal.show()
      }
    })
    this.modalData.show = false
  }

  __downloadFile (fileSrc, fileName = 'downloaded_file', extension = '.xls') {
    const link = document.createElement('a')
    link.style = 'display: none'
    link.download = `${fileName}${extension}`
    link.href = fileSrc
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  get nmInterface () {
    return this.interface
  }

  get page () {
    return ContractPage
  }

  get pageDetail () {
    return PageDetail
  }

  get pageUpdate () {
    return ContractUpdate
  }

  get pageTable () {
    return ContractPageTable
  }
}
export default Contract
</script>
<style lang="stylus" scoped>
 .q-card {
   padding: 20px;
 }
 .q-toolbar{
   height: 60px
 }
 .q-toolbar__title{
   padding: 3px 20px !important;
 }
 .fit {
   margin-top: 0;
 }
 .data-card-main.q-card__section {
   margin-top: -20px ;
 }
 .q-card > div {
   padding-bottom: 0 !important;
 }

</style>
